import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Cookies from "universal-cookie";
import { Container, Row, Col, Table, Image } from "react-bootstrap";
import logo from "../assets/mboxLogo.jpeg";

const API_HOST = process.env.REACT_APP_API_URL;
const API = process.env.REACT_APP_API_KEY;
const cookies = new Cookies();

const ImprimirFacturaTermica = () => {
  const { idFactura } = useParams();
  const [factura, setFactura] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchFactura = async () => {
      const bearertoken = cookies.get("token");
      try {
        const response = await fetch(
          `${API_HOST}/facturas/imprimirFactura/${idFactura}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${bearertoken}`,
              API: API,
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        console.log(factura)
        setFactura(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFactura();
  }, [idFactura]);

  if (loading)
    return <div className='text-center mt-4'>Cargando factura...</div>;
  if (error)
    return <div className='text-center mt-4 text-danger'>Error: {error}</div>;
  if (!factura)
    return <div className='text-center mt-4'>No se encontró la factura</div>;

  const {
    factura: facturaData,
    informacionSar,
    ordenPaquete,
    rtnInfo,
  } = factura;

  const {
    cai,
    rtn: rtnSar,
    correlativo: correlativoSar,
    rangoInicial,
    rangoFinal,
    fechaLimiteEmision,
  } = informacionSar;
  const { fechaEmision, correlativo } = facturaData;
  const { cliente, ordenes } = ordenPaquete;
  console.log(ordenes)

  // Calcular totales
  const subtotal = ordenes.reduce(
    (acc, orden) => acc + parseFloat(orden.subtotal),
    0
  );
  const isv = ordenes.reduce((acc, orden) => acc + parseFloat(orden.isv), 0);
  const descuento = ordenes.reduce(
    (acc, orden) => acc + parseFloat(orden.descuento),
    0
  );
  const total = ordenes.reduce(
    (acc, orden) => acc + parseFloat(orden.total),
    0
  );

  // Formatear fecha
  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return new Date(dateString).toLocaleDateString("es-HN", options);
  };

  return (
    <Container
      className='invoice-container p-3'
      style={{
        maxWidth: "100mm",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        border: "1px solid #ddd",
        boxShadow: "0 0 8px rgba(0,0,0,0.05)",
      }}
    >
      {/* Encabezado */}
      <Row className='mb-3 text-center'>
        <Col>
          <h2
            className='mb-1'
            style={{ color: "#333", fontWeight: "600", fontSize: "1.5rem" }}
          >
            MBOX S. De R.L
          </h2>
          <div
            className='logo-placeholder mb-2'
            style={{
              height: "50px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto",
            }}
          >
            <Image
              src={logo}
              alt='Logo MBOX'
              fluid
              className='mb-3 mt-3'
              style={{
                maxHeight: "60px",
                width: "auto",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            />
          </div>
        </Col>
      </Row>

      {/* Información de la factura */}
      <div className='invoice-header mb-3'>
        <Row className='mb-2'>
          <Col>
            <h5
              style={{
                color: "#333",
                fontWeight: "500",
                borderBottom: "1px solid #333",
                paddingBottom: "4px",
                fontSize: "1rem",
              }}
            >
              FACTURA #{correlativoSar}-{String(correlativo).padStart(8, "0")}
            </h5>
          </Col>
        </Row>

        <div style={{ lineHeight: "1.6" }}>
          <div>
            <strong>Fecha:</strong> {(fechaEmision).slice(0,10)}
          </div>
          <div>
       <strong>Concepto:</strong> Traslado de paquete {ordenes[0]?.paquete?.origen || "Origen no disponible"} - HONDURAS
          </div>
          <div>
            <strong>CAI:</strong> {cai}
          </div>
          <div>
            <strong>RTN:</strong> {rtnSar}
          </div>
          <div>
            <strong>Rango:</strong> {correlativoSar}-
            {String(rangoInicial).padStart(8, "0")} / {correlativoSar}-
            {String(rangoFinal).padStart(8, "0")}
          </div>
          <div>
            <strong>Válido hasta:</strong> {(fechaLimiteEmision).slice(0,10)}
          </div>
        </div>
      </div>

      {/* Información del cliente */}
      <div className='client-info mb-3'>
        <h6
          style={{
            color: "#333",
            borderBottom: "1px solid #333",
            paddingBottom: "4px",
            marginBottom: "8px",
            fontSize: "0.9rem",
          }}
        >
          DATOS DEL CLIENTE
        </h6>
        <div style={{ lineHeight: "1.6" }}>
          <div>
            <strong>Nombre:</strong> {cliente.nombre}
          </div>
          <div>
            <strong>Identidad:</strong> {cliente.identidad}
          </div>
          <div>
            <strong>Teléfono:</strong>
            {cliente.telefono}
          </div>
          <div>
            <strong>Cliente:</strong> {facturaData.tipoCliente}
          </div>
          {rtnInfo?.rtn?.nombre && (
            <div>
              <strong>Nombre:</strong> {rtnInfo.rtn.nombre}
            </div>
          )}
          {rtnInfo?.rtn?.rtn && (
            <div>
              <strong>RTN:</strong> {rtnInfo.rtn.rtn}
            </div>
          )}
        </div>
      </div>

      {/* Detalles de los paquetes */}
      <h6
        style={{
          color: "#333",
          borderBottom: "1px solid #333",
          paddingBottom: "4px",
          marginBottom: "8px",
          fontSize: "0.9rem",
        }}
      >
        DETALLES DE PAQUETES
      </h6>
      <Table
        borderless
        size='sm'
        className='mb-3'
        style={{ fontSize: "0.85rem" }}
      >
        <thead>
          <tr style={{ borderBottom: "1px solid #ddd" }}>
            <th style={{ fontWeight: "500", padding: "4px 0" }}>Tracking</th>
            <th style={{ fontWeight: "500", padding: "4px 0" }}>Tipo</th>
            <th
              style={{
                fontWeight: "500",
                padding: "4px 0",
                textAlign: "right",
              }}
            >
              Peso
            </th>
          </tr>
        </thead>
        <tbody>
          {ordenes.map((orden, index) => (
            <tr key={index} style={{ borderBottom: "1px solid #f1f1f1" }}>
                 <td style={{ padding: "6px 0", fontSize: "0.75rem" }}>
                {orden.paquete.tracking.length > 12
                  ? `${orden.paquete.tracking.substring(
                      0,
                      6
                    )}...${orden.paquete.tracking.slice(-6)}`
                  : orden.paquete.tracking}
              </td>
              <td style={{ padding: "6px 0" }}>{orden.paquete.tipoEnvio}</td>
              <td style={{ padding: "6px 0", textAlign: "right" }}>
                {orden.paquete.pesoMbox} lbs
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Totales */}
      <div
        className='totals mb-3'
        style={{
          borderTop: "1px solid #333",
          borderBottom: "1px solid #333",
          padding: "8px 0",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Subtotal:</span>
          <span>L. {subtotal.toFixed(2)}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>Descuento:</span>
          <span>L. {descuento.toFixed(2)}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>ISV (15%):</span>
          <span>L. {isv.toFixed(2)}</span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "4px",
            paddingTop: "4px",
            borderTop: "1px dashed #aaa",
          }}
        >
          <strong>TOTAL:</strong>
          <strong style={{ fontSize: "1.1rem" }}>L. {total.toFixed(2)}</strong>
        </div>
      </div>

      {/* Método de pago */}
      <div className='payment-method mb-3'>
        <h6
          style={{
            color: "#333",
            borderBottom: "1px solid #333",
            paddingBottom: "4px",
            marginBottom: "8px",
            fontSize: "0.9rem",
          }}
        >
          MÉTODO DE PAGO
        </h6>
        <div style={{ lineHeight: "1.6" }}>
          <div>
            <strong>Método:</strong> {facturaData.metodoPago}
          </div>
          {facturaData.comprobantePago && (
            <div>
              <strong>Comprobante:</strong> {facturaData.comprobantePago}
            </div>
          )}
        </div>
      </div>

      {/* Información fiscal (sin título) */}
      <div
        className='text-center mb-2'
        style={{ fontSize: "0.75rem", color: "#555" }}
      >
        <div style={{ marginBottom: "4px" }}>
          Esta factura es un comprobante fiscal | Original: Cliente - Copia:
          Emisor
        </div>
        <div style={{ marginBottom: "4px" }}>
          Bulevar Centro América, Edificio Corporativo C.A 5 Piso 3<br />
          Tegucigalpa, Honduras | Tel: 2230-0800
        </div>
      </div>

      {/* Pie de página */}
      <div
        className='footer text-center'
        style={{ fontSize: "0.85rem", fontWeight: "500" }}
      >
        ¡Gracias por su preferencia!
      </div>
    </Container>
  );
};

export default ImprimirFacturaTermica;
